// Bu proje farklı domainlerde beyaz-etiket (white-label) klonlar olarak
// yayınlanıyor: repo kopyalanıp logo/tema değiştirilir, BaseServiceURLs.jsx
// güncellenir ve ayrı build alınıp deploy edilir.
//
// Bu dosya, her klon için build almadan önce true/false olarak düzenlenen
// merkezi özellik anahtarlarını içerir. Bir özellik false yapıldığında ona
// bağlı tüm giriş noktaları (menü linki, buton, route, my-account sekmesi
// vb.) da otomatik olarak kalkar.
//
// NOT: Bu flag'ler `permissions` (GET_AVAIABLE_SETTING'den gelen
// SPORTS_ACCESS, CASINO_ACCESS vb.) ile karıştırılmamalı. `permissions`
// backend'den gelen kullanıcı/tenant bazlı yetkidir; SiteFeatures ise
// build-time, sitenin tamamı için geçerli frontend anahtarıdır.
export const SiteFeatures = {
  // true: login olmadan hiçbir içerik (oyun, kategori vb.) görüntülenemez,
  // ziyaretçi zorunlu login ekranına yönlendirilir.
  CLOSED_SYSTEM: false,

  // false: "Create account" / kayıt ol akışı tamamen kalkar, sadece login
  // formu gösterilir.
  ONLINE_REGISTER: true,

  // false: bakiye yükleme (deposit) ve para çekme (withdraw) sistemi ve ona
  // bağlı her şey (deposit/withdraw butonları, ödeme yöntemleri şeridi,
  // "para çekme talepleri" sekmesi vb.) tamamen kalkar.
  DEPOSIT_SYSTEM: false,

  // false: bonus sistemi ve ona bağlı her şey (bonus sayfası, bonus cüzdanı,
  // bonus talebi butonu/modalı, "bonus talepleri" sekmesi vb.) tamamen kalkar.
  BONUS_SYSTEM: true,
};
